
import { locationsInfoType } from '@/types/Common';
import { Component, Prop, Vue } from 'vue-property-decorator';
import {bclogo} from '../../../../public/images/bclogo-icon';


@Component
export default class FamilyLawMatterInstructions extends Vue {

    @Prop({required: true})
    locationInfo!: locationsInfoType;

    @Prop({required: true})
    earlyResolution!: boolean;

    bcLogo = bclogo;
    locationNameHeading = '';
    dataReady = false;

    mounted(){        
        this.dataReady = false;
        if (this.earlyResolution){

            if (this.locationInfo.name.toLowerCase() == 'victoria law courts'){
                this.locationNameHeading = 'Victoria Provincial Courts'

            } else {
                this.locationNameHeading = this.locationInfo.name;
            }

        }

        this.dataReady = true;
    }

}
